import { trackEvent } from "@lululemon/mwa-analytics";
import logger, { LapelError } from "../../../logger";
var MWAAnalyticsReceiver = function(param) {
    var name = param.name, value = param.value;
    return trackEvent(name, value).catch(function(error) {
        logger.debug(new LapelError(error.message + " while trying to send " + name + ":" + value + " event to mwa-analytics", {
            cause: error
        }));
    });
};
export default MWAAnalyticsReceiver;

//# sourceMappingURL=index.js.map